import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/home'
// import push from './push'
import admin from './admin'
import createEval from './createEval'
import organization from './organization'
import notice from './notice'
import login from './login'
import giasInput from './giasInput'
import store from '../store'
import QGC from './QGC'
const router = createRouter({
    history: createWebHistory(),
    // routes: dynamic(store)
    routes: [
        {
            path: '/', 
            name: 'Home', 
            component: Home,
            
        },
        ...createEval,
        ...admin,
        ...notice,
        ...login,
        ...organization,
        ...giasInput,
        ...QGC
    ]
})

export default router;  
